module.exports = __webpack_public_path__ + "static/en-3-efbc420c9d660e6251f33006aa328996.png";